import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDashboardStore } from '../stores/dashboardStore';
import './Header.css';

const Header: React.FC = () => {
    const { config } = useDashboardStore();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleSubMenu = (navId: string) => {
        setActiveSubMenu(activeSubMenu === navId ? null : navId);
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/">
                        <h1>{config.personalInfo.name}</h1>
                        <span>{config.personalInfo.title}</span>
                    </Link>
                </div>

                <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
                    <ul className="nav-list">
                        {config.navigation.mainNav.map((nav) => (
                            <li key={nav.id} className="nav-item">
                                {nav.subNav ? (
                                    <div
                                        className="nav-dropdown"
                                        onMouseEnter={() => setActiveSubMenu(nav.id)}
                                        onMouseLeave={() => setActiveSubMenu(null)}
                                    >
                                        <button
                                            className={`nav-link nav-button ${activeSubMenu === nav.id ? 'active' : ''}`}
                                            onClick={() => {
                                                toggleSubMenu(nav.id);
                                                setIsMobileMenuOpen(false);
                                            }}
                                        >
                                            {nav.title}
                                            <span className="arrow">▼</span>
                                        </button>
                                        <ul className={`sub-nav ${activeSubMenu === nav.id ? 'sub-nav-open' : ''}`}>
                                            {nav.subNav.map((subNav) => (
                                                <li key={subNav.id} className="sub-nav-item">
                                                    <Link
                                                        to={subNav.path}
                                                        className="sub-nav-link"
                                                        onClick={() => {
                                                            setIsMobileMenuOpen(false);
                                                            setActiveSubMenu(null);
                                                        }}
                                                    >
                                                        {subNav.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : (
                                    <Link
                                        to={nav.path}
                                        className={`nav-link ${location.pathname === nav.path ? 'active' : ''}`}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        {nav.title}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>

                <button
                    className="mobile-menu-toggle"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle mobile menu"
                >
                    <span className="hamburger"></span>
                    <span className="hamburger"></span>
                    <span className="hamburger"></span>
                </button>
            </div>
        </header>
    );
};

export default Header;


